// Country-specific address field configurations

export const COUNTRIES = [
  { code: 'US', name: 'United States' },
  { code: 'CA', name: 'Canada' },
  { code: 'JM', name: 'Jamaica' },
  { code: 'JP', name: 'Japan' },
];

export const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA',
  'HI','ID','IL','IN','IA','KS','KY','LA','ME','MD',
  'MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
  'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC',
  'SD','TN','TX','UT','VT','VA','WA','WV','WI','WY',
];

export const CA_PROVINCES = [
  'AB','BC','MB','NB','NL','NS','NT','NU','ON','PE','QC','SK','YT',
];

export const CA_PROVINCE_NAMES: Record<string, string> = {
  AB: 'Alberta', BC: 'British Columbia', MB: 'Manitoba',
  NB: 'New Brunswick', NL: 'Newfoundland and Labrador', NS: 'Nova Scotia',
  NT: 'Northwest Territories', NU: 'Nunavut', ON: 'Ontario',
  PE: 'Prince Edward Island', QC: 'Quebec', SK: 'Saskatchewan', YT: 'Yukon',
};

export const JM_PARISHES = [
  'Clarendon','Hanover','Kingston','Manchester','Portland',
  'St. Andrew','St. Ann','St. Catherine','St. Elizabeth',
  'St. James','St. Mary','St. Thomas','Trelawny','Westmoreland',
];

export const JP_PREFECTURES = [
  'Hokkaido','Aomori','Iwate','Miyagi','Akita','Yamagata','Fukushima',
  'Ibaraki','Tochigi','Gunma','Saitama','Chiba','Tokyo','Kanagawa',
  'Niigata','Toyama','Ishikawa','Fukui','Yamanashi','Nagano',
  'Gifu','Shizuoka','Aichi','Mie',
  'Shiga','Kyoto','Osaka','Hyogo','Nara','Wakayama',
  'Tottori','Shimane','Okayama','Hiroshima','Yamaguchi',
  'Tokushima','Kagawa','Ehime','Kochi',
  'Fukuoka','Saga','Nagasaki','Kumamoto','Oita','Miyazaki','Kagoshima','Okinawa',
];

export interface AddressFieldConfig {
  streetLabel: string;
  cityLabel: string;
  regionLabel: string;
  regionOptions: string[] | null; // null = free text, array = dropdown
  postalLabel: string | null; // null = no postal code field
  postalFormat?: string; // helper text
  postalMaxLength?: number;
  // For Japan, address fields are in reversed order
  postalFirst?: boolean;
}

export function getAddressConfig(country: string): AddressFieldConfig {
  switch (country) {
    case 'CA':
      return {
        streetLabel: 'Street Address',
        cityLabel: 'City',
        regionLabel: 'Province',
        regionOptions: CA_PROVINCES,
        postalLabel: 'Postal Code',
        postalFormat: 'A1A 1A1',
        postalMaxLength: 7,
      };
    case 'JM':
      return {
        streetLabel: 'Street Address',
        cityLabel: 'City / Town',
        regionLabel: 'Parish',
        regionOptions: JM_PARISHES,
        postalLabel: null, // Jamaica doesn't use postal codes
      };
    case 'JP':
      return {
        streetLabel: 'Street Address (番地)',
        cityLabel: 'City / Ward (市区町村)',
        regionLabel: 'Prefecture (都道府県)',
        regionOptions: JP_PREFECTURES,
        postalLabel: 'Postal Code (郵便番号)',
        postalFormat: 'xxx-xxxx',
        postalMaxLength: 8,
        postalFirst: true,
      };
    case 'US':
    default:
      return {
        streetLabel: 'Street Address',
        cityLabel: 'City',
        regionLabel: 'State',
        regionOptions: US_STATES,
        postalLabel: 'ZIP Code',
        postalFormat: '5 digits',
        postalMaxLength: 10,
      };
  }
}

// Format display name for region codes
export function getRegionDisplayName(country: string, code: string): string {
  if (country === 'CA') return CA_PROVINCE_NAMES[code] || code;
  return code;
}
